//////////////////////////////////////////////////////////////////////
//
//  09/28/18
//  src/containers/MainCompact.js
//
//  This file is the top level MainCompact javascript file.
//

import React, { Component } from "react";
import CompactRow from "../components/CompactRow";
import BarData    from "../components/BarData";
import RestData   from "../components/RestData";
import MusicData  from "../components/MusicData";
import GrillData  from "../components/GrillData";
import { IRH_myModal } from "../components/IconRowHelp";
import './MainCompact.css';

class MainCompact extends Component {
  render() {
    const { navbar } = this.props;
    const bIdx = 10;
    console.log( "MainCompact Props.navbar.sCat: " + navbar.sCat );
    
    var title = "";
    var xdata = {};

    switch( navbar.sCat ) {
    case 'bars':   xdata = this.formatData( BarData,   bIdx );    title="Bars";               break;
    case 'rests':  xdata = this.formatData( RestData,  bIdx );    title="Restaurants";        break;
    case 'music':  xdata = this.formatData( MusicData, bIdx );    title="Music";              break;
    default:       xdata = this.formatData( GrillData, bIdx );    title="Bar and Grills";     break;
    }

    return (
      <div id="MainCompactTop">
        <div id="MainCompactTitle">{ title }</div>
        <div id="MainCompactBody">{ xdata }</div>
 
        <div id={ 'myModal' }  style={ IRH_myModal }>
        </div>

      </div>
    );
  }
  
  ///////////////////////////////////////////////////////////
  //
  //  Format the data to layout on the screen
  //
  formatData( cData, rNum ) {
    var tmpData = cData.map( ( val, idx ) => {
      //console.log( "Index: " + ( idx + bIdx ) + ", Name: " + val.name ); 
        return( 
          <CompactRow 
            key = { idx } 
            miles={ val.miles } 
            name ={ val.name  } 
            row  ={ idx+rNum  } 
            music={ val.music }
            food ={ val.food  }
            happy={ val.happy }
            notes={ val.notes }
            mpop ={ val.mpop  }
            fpop ={ val.fpop  }
            hpop ={ val.hpop  }
            addr ={ val.addr  }
          />
        );
      });
    return tmpData;
  }
}

export default MainCompact;



// WEBPACK FOOTER //
// ./src/containers/MainCompact.js